import Button from "../../Tools/Components/Button";

function KvkOpt(props) {
    var leftFieldName = props.kvkOpt.emailOntvanger;
    var rightFieldName = props.kvkOpt.kvk;
    var editing = props.editing;
    var onLeftChanged = props.onLeftChanged;
    var onRightChanged = props.onRightChanged;
    var onDeletePressed = props.onDeletePressed;
    var id = props.index;
    
    var left = GetEditableField(onLeftChanged, leftFieldName, editing);
    var right = GetEditableField(onRightChanged, rightFieldName, editing);

    return (
        <div className="content-stretch flex gap-[7px] items-center relative shrink-0 w-full" id={"va" + id}>
            {left}
            <div>:</div>
            {right}
            {editing ? <Button text="X" onClick={onDeletePressed} width="30" height="30"/> : ""}
        </div>
    );
} export default KvkOpt

function GetEditableField(callback, value, editing){
    return (<input onChange={value => callback(value.target.value)} className="bg-[#ffffff] bg-black-override h-[23px] relative shrink-0 w-[320px] absolute border border-black border-solid inset-0" defaultValue={value} readOnly={!editing}/>)
}